export var getMapStateToPaymentMethodSectionProps = function getMapStateToPaymentMethodSectionProps(_ref) {
  var mapStateToPaymentButtonProps = _ref.mapStateToPaymentButtonProps,
    mapStateToPaymentOptionsProps = _ref.mapStateToPaymentOptionsProps,
    mapStateToQuickPaymentOptionsProps = _ref.mapStateToQuickPaymentOptionsProps;
  return function (state, setState) {
    return {
      paymentButtonProps: mapStateToPaymentButtonProps(state, setState),
      paymentOptionProps: mapStateToPaymentOptionsProps(state, setState),
      quickPaymentOptionProps: mapStateToQuickPaymentOptionsProps(state, setState)
    };
  };
};